export default __webpack_public_path__ + "static/media/inr.5908c083.png";